import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-download-app',
  templateUrl: './svg-download-app.component.html',
})
export class SvgDownloadAppComponent {
  constructor() {}
}
